// Fix autocomplete width to match textbox.
jQuery.ui.autocomplete.prototype._resizeMenu = function () {
	let ul = this.menu.element;
	ul.outerWidth( this.element.outerWidth() );
}

jQuery( function ( $ ) {
	$( '.ui-autocomplete' ).each( function () {
		let form = $( this ).closest( 'form' );

		$( this ).autocomplete( {
			source: function( request, response ) {
				$.ajax( {
					url: form.data( 'url' ),
					dataType: 'json',
					type: 'POST',
					data: {
						term: request.term,
						action: form.data( 'action' ),
					},
					success: function( data ) {
						response( $.map ( data, function( item ) {
							return {
								value: item.value,
								label: item.label,
								href: item.href,
							}
						}));
					}
				} );
			},
		// Allow HTML in label.
		} ).data( 'ui-autocomplete' )._renderItem = function ( ul, item ) {
			return $( '<li></li>' ).data( 'item.autocomplete', item ).append( '<a href="' + item.href + '">' + item.label + '</a>' ).appendTo( ul );
		};
	} );
} );
